import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { FormData } from './types'
import { initializeFormValues } from './utils'

export const useProductFormInitialization = (
  product: any,
  methods: UseFormReturn<FormData>
) => {
  useEffect(() => {
    if (product) {
      // Get form values and reset form with them to mark it as clean (not dirty)
      const formValues = initializeFormValues(product)
      if (formValues) {
        methods.reset(formValues)
      }
    }
  }, [product, methods])
}

